/* RESPONSIBLE TEAM: team-standalone */

import { CHANNEL_FRESHDESK_TICKET } from 'embercom/lib/operator/custom-bots/constants';
import { ChannelTargetingBodyData } from '../definitions';

export default class FreshdeskChannelTargetingBodyData extends ChannelTargetingBodyData {
  get addMessengerChannel() {
    return true;
  }

  get channelGroupTitleKey() {
    return 'operator.workflows.channels.groupings.freshdesk';
  }

  get channels() {
    return [
      {
        value: CHANNEL_FRESHDESK_TICKET,
        icon: 'freshdesk',
        requiresAppStoreInstallation: false,
        // eslint-disable-next-line @intercom/intercom/no-bare-strings
        channelTypeValue: 'Freshdesk',
        isSetup: true,
      } as const,
    ];
  }
}
